import { Box, Typography, Button } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { SvgIconTypeMap } from "@mui/material/SvgIcon";

interface InfoBoxProps {
  title: string;
  description: string;
  icon: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
}

const InfoBox: React.FC<InfoBoxProps> = ({
  title,
  description,
  icon: IconComponent,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "start",
        height: "100%",
      }}
    >
      <Box
        sx={{
          marginRight: "24px",
        }}
      >
        <IconComponent
          color="primary"
          sx={{
            fontSize: {
              xs: "36px",
              md: "50px",
            },
          }}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "start",
          height: "100%",
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: 500,
              marginBottom: "4px",
            }}
          >
            {title}
          </Typography>

          <Typography
            color="#6E6E6E"
            sx={{
              fontSize: "16px",
              fontWeight: 300,
            }}
          >
            {description}
          </Typography>
        </Box>

        {/* <Button
          sx={{
            marginTop: "16px",
          }}
          variant="text"
        >
          Learn More
        </Button> */}
      </Box>
    </Box>
  );
};

export default InfoBox;
